import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "./axios";

// Team Admin: Submit payment
const submitPayment = createAsyncThunk(
  "teamPayment/submitPayment",
  async (data, { rejectWithValue }) => {
    try {
      const headers = { "Content-Type": "application/json" };
      const response = await axios.post(
        "/team-payments/submit",
        JSON.stringify(data),
        {
          headers,
        }
      );
      return response.data;
    } catch (err) {
      console.error(err);
      return rejectWithValue(
        err.response?.data?.message || "Failed to submit payment"
      );
    }
  }
);

// Team Admin: Get my team's payment history
const getMyTeamPayments = createAsyncThunk(
  "teamPayment/getMyTeamPayments",
  async (_, { rejectWithValue }) => {
    try {
      const headers = { "Content-Type": "application/json" };
      const response = await axios.get("/team-payments/my-team", {
        headers,
      });
      return response.data;
    } catch (err) {
      console.error(err);
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch team payments"
      );
    }
  }
);

// Superadmin: Get all periods for a team
const getTeamPeriods = createAsyncThunk(
  "teamPayment/getTeamPeriods",
  async (teamId, { rejectWithValue }) => {
    try {
      const headers = { "Content-Type": "application/json" };
      const response = await axios.get(
        `/team-payments/teams/${teamId}/periods`,
        {
          headers,
        }
      );
      return response.data;
    } catch (err) {
      console.error(err);
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch team periods"
      );
    }
  }
);

// Superadmin: Get period details
const getPeriodDetails = createAsyncThunk(
  "teamPayment/getPeriodDetails",
  async (periodId, { rejectWithValue }) => {
    try {
      const headers = { "Content-Type": "application/json" };
      const response = await axios.get(`/team-payments/periods/${periodId}`, {
        headers,
      });
      return response.data;
    } catch (err) {
      console.error(err);
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch period details"
      );
    }
  }
);

// Superadmin: Get pending payments
const getPendingPayments = createAsyncThunk(
  "teamPayment/getPendingPayments",
  async (teamId = null, { rejectWithValue }) => {
    try {
      const headers = { "Content-Type": "application/json" };
      const url = teamId
        ? `/team-payments/pending?teamId=${teamId}`
        : "/team-payments/pending";
      const response = await axios.get(url, {
        headers,
      });
      return response.data;
    } catch (err) {
      console.error(err);
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch pending payments"
      );
    }
  }
);

// Superadmin: Approve payment
const approvePayment = createAsyncThunk(
  "teamPayment/approvePayment",
  async ({ paymentId, periodId }, { rejectWithValue }) => {
    try {
      const headers = { "Content-Type": "application/json" };
      const response = await axios.patch(
        `/team-payments/approve/${paymentId}`,
        JSON.stringify({ periodId }),
        {
          headers,
        }
      );
      return response.data;
    } catch (err) {
      console.error(err);
      return rejectWithValue(
        err.response?.data?.message || "Failed to approve payment"
      );
    }
  }
);

// Superadmin: Reject payment
const rejectPayment = createAsyncThunk(
  "teamPayment/rejectPayment",
  async ({ paymentId, periodId, rejectionReason }, { rejectWithValue }) => {
    try {
      const headers = { "Content-Type": "application/json" };
      const response = await axios.patch(
        `/team-payments/reject/${paymentId}`,
        JSON.stringify({ periodId, rejectionReason }),
        {
          headers,
        }
      );
      return response.data;
    } catch (err) {
      console.error(err);
      return rejectWithValue(
        err.response?.data?.message || "Failed to reject payment"
      );
    }
  }
);

// Superadmin: Initialize payment period
const initializePaymentPeriod = createAsyncThunk(
  "teamPayment/initializePaymentPeriod",
  async (teamId, { rejectWithValue }) => {
    try {
      const headers = { "Content-Type": "application/json" };
      const response = await axios.post(
        "/team-payments/initialize-period",
        JSON.stringify({ teamId }),
        {
          headers,
        }
      );
      return response.data;
    } catch (err) {
      console.error(err);
      return rejectWithValue(
        err.response?.data?.message || "Failed to initialize payment period"
      );
    }
  }
);

export {
  submitPayment,
  getMyTeamPayments,
  getTeamPeriods,
  getPeriodDetails,
  getPendingPayments,
  approvePayment,
  rejectPayment,
  initializePaymentPeriod,
};




